import PageBackTitle from "../Component/PageBackTitle";
// --------------------------- old correct code ---------------------------

// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import "./Form.css";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import API_URL from "../../src/Config";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { format } from "date-fns";
// import { RxCrossCircled } from "react-icons/rx";
// import { setHours, setMinutes } from "date-fns";
// import Chip from "@mui/material/Chip";
// import Stack from "@mui/material/Stack";

// function PermitRequestForm({ isSidebarExpanded }) {
//   // State declarations
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const { id } = useParams();
//   console.log("Fetched ID:", id);
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();
//   const [permitType, setPermitType] = useState([]);
//   const [selectedPermitType, setSelectedPermitType] = useState(null);
//   const [fields, setFields] = useState([]);
//   const [dropdownOptions, setDropdownOptions] = useState({});
//   const [dynamicApiEndpoint, setDynamicApiEndpoint] = useState("");
//   const [selectedOptions, setSelectedOptions] = useState({});
//   const [dateValues, setDateValues] = useState({});
//   const [dynamicSubFields, setDynamicSubFields] = useState([]);
//   const [formData, setFormData] = useState({
//     section: "",
//     department_id: "",
//     form_id: "",
//     area: "",
//     equipment_no: "",
//     issued_to: "",
//     work_description: "",
//     contractor: "",
//     unit: "",
//     location: "",
//     valid_from: "",
//     valid_to: "",
//     receiver_name: "",
//     permit_type_id: "",
//     department: "",
//   });

//   // ============================================
//   // FULLY DYNAMIC VALIDATION FUNCTION
//   // ============================================
//   const validateRequiredFields = (request_status) => {
//     const errors = {};

//     // 1. Validate permit type selection (always required)
//     if (!selectedPermitType?.value) {
//       errors.selectedPermitType = "Permit Type is required";
//     }

//     // 2. Validate dynamic fields from permit type configuration
//     fields.forEach((field) => {
//       if (Number(field.is_required) === 1) {
//         const fieldName = field.field_name;
//         const fieldLabel = field.field_label;

//         if (field.field_type === "dropdown") {
//           if (field.is_multiple) {
//             // Multi-select dropdown validation
//             if (!selectedOptions[field.id]?.length) {
//               errors[fieldName] = `${fieldLabel} is required`;
//             }
//           } else {
//             // Single-select dropdown validation
//             // Check both formData and selectedOptions
//             const hasValueInFormData =
//               formData[fieldName] && formData[fieldName] !== "";
//             const hasValueInSelectedOptions = selectedOptions[field.id]?.value;

//             if (!hasValueInFormData && !hasValueInSelectedOptions) {
//               errors[fieldName] = `${fieldLabel} is required`;
//             }
//           }
//         } else if (field.field_type === "date") {
//           if (!dateValues[fieldLabel]) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else if (field.field_type === "checkbox") {
//           const checkboxValues = formData[fieldName];
//           if (
//             !checkboxValues ||
//             (Array.isArray(checkboxValues) && checkboxValues.length === 0)
//           ) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else {
//           // Text, number, textarea validation
//           const value = formData[fieldName];
//           if (!value || (typeof value === "string" && !value.trim())) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         }
//       }
//     });

//     // 3. Validate dynamic sub-fields (dependent fields based on parent selection)
//     dynamicSubFields.forEach((subField) => {
//       if (Number(subField.is_required) === 1) {
//         const fieldName = subField.field_name;
//         const fieldLabel = subField.field_label;

//         if (subField.field_type === "dropdown") {
//           // For department dropdown, check department_id instead of department_name
//           if (fieldName === "department_name") {
//             if (!formData.department_id || formData.department_id === "") {
//               errors.department_id = `${fieldLabel} is required`;
//             }
//           } else {
//             // For other dropdowns, check the field value
//             if (!formData[fieldName] || formData[fieldName] === "") {
//               errors[fieldName] = `${fieldLabel} is required`;
//             }
//           }
//         } else if (subField.field_type === "date") {
//           if (!dateValues[fieldLabel]) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else if (subField.field_type === "checkbox") {
//           const checkboxValues = formData[fieldName];
//           if (
//             !checkboxValues ||
//             (Array.isArray(checkboxValues) && checkboxValues.length === 0)
//           ) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else {
//           const value = formData[fieldName];
//           if (!value || (typeof value === "string" && !value.trim())) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         }
//       }
//     });

//     // 4. Validate date range if both dates exist
//     const startDateField = fields.find(
//       (f) => f.field_label === "Start Date & Time",
//     );
//     const endDateField = fields.find(
//       (f) => f.field_label === "End Date & Time",
//     );

//     if (startDateField && endDateField) {
//       const startDate = dateValues[startDateField.field_label];
//       const endDate = dateValues[endDateField.field_label];

//       if (startDate && endDate && startDate >= endDate) {
//         errors[endDateField.field_name] = "End date must be after start date";
//       }
//     }

//     console.log("=== VALIDATION DEBUG ===");
//     console.log("Validation Errors:", errors);
//     console.log("FormData:", formData);
//     console.log("DateValues:", dateValues);
//     console.log("SelectedOptions:", selectedOptions);
//     console.log("Fields:", fields);
//     console.log("DynamicSubFields:", dynamicSubFields);
//     console.log("=======================");

//     return errors;
//   };

//   // ============================================
//   // FULLY DYNAMIC PAYLOAD BUILDER
//   // ============================================
//   const buildDynamicPayload = (request_status) => {
//     const payload = {
//       // Core system fields
//       permit_type_id: selectedPermitType?.value,
//       request_status,
//     };

//     // Process all dynamic fields from permit type configuration
//     fields.forEach((field) => {
//       const fieldName = field.field_name;
//       const fieldLabel = field.field_label;

//       switch (field.field_type) {
//         case "dropdown":
//           if (field.is_multiple) {
//             // Multi-select: array of IDs
//             payload[fieldName] = selectedOptions[field.id]
//               ? selectedOptions[field.id].map((item) => item.value)
//               : [];
//           } else {
//             // Single-select: single ID or empty string
//             // Check if value is stored in formData (for issued_to and similar fields)
//             if (formData[fieldName]) {
//               payload[fieldName] = formData[fieldName];
//             } else if (selectedOptions[field.id]) {
//               payload[fieldName] = selectedOptions[field.id].value;
//             } else {
//               payload[fieldName] = "";
//             }
//           }
//           break;

//         case "date":
//           // Date fields with time
//           if (dateValues[fieldLabel]) {
//             payload[fieldName] = format(
//               dateValues[fieldLabel],
//               "yyyy-MM-dd HH:mm:ss",
//             );
//           } else {
//             payload[fieldName] = null;
//           }
//           break;

//         case "checkbox":
//           // Checkbox: always an array
//           const checkboxValues = formData[fieldName];
//           if (Array.isArray(checkboxValues)) {
//             payload[fieldName] = checkboxValues;
//           } else if (checkboxValues) {
//             payload[fieldName] = [checkboxValues];
//           } else {
//             payload[fieldName] = [];
//           }
//           break;

//         case "number":
//           // Convert to number or null
//           const numValue = formData[fieldName];
//           payload[fieldName] =
//             numValue && numValue !== "" ? Number(numValue) : null;
//           break;

//         default:
//           // Text, textarea, etc.
//           const textValue = formData[fieldName];
//           payload[fieldName] =
//             textValue && typeof textValue === "string"
//               ? textValue.trim()
//               : textValue || "";
//       }
//     });

//     // Process dynamic sub-fields (dependent fields)
//     dynamicSubFields.forEach((subField) => {
//       const fieldName = subField.field_name;
//       const fieldLabel = subField.field_label;

//       switch (subField.field_type) {
//         case "dropdown":
//           // Special case: For department field, use department_id instead of department_name
//           if (fieldName === "department_name") {
//             // Pass department_id in payload, not department_name
//             payload["department_id"] = formData.department_id || "";
//           } else {
//             // For other dropdowns, use the field value directly
//             payload[fieldName] = formData[fieldName] || "";
//           }
//           break;

//         case "date":
//           if (dateValues[fieldLabel]) {
//             payload[fieldName] = format(
//               dateValues[fieldLabel],
//               "yyyy-MM-dd HH:mm:ss",
//             );
//           } else {
//             payload[fieldName] = null;
//           }
//           break;

//         case "checkbox":
//           const checkboxValues = formData[fieldName];
//           if (Array.isArray(checkboxValues)) {
//             payload[fieldName] = checkboxValues;
//           } else if (checkboxValues) {
//             payload[fieldName] = [checkboxValues];
//           } else {
//             payload[fieldName] = [];
//           }
//           break;

//         case "number":
//           const numValue = formData[fieldName];
//           payload[fieldName] =
//             numValue && numValue !== "" ? Number(numValue) : null;
//           break;

//         default:
//           // Text, textarea
//           const textValue = formData[fieldName];
//           payload[fieldName] =
//             textValue && typeof textValue === "string"
//               ? textValue.trim()
//               : textValue || "";
//       }
//     });

//     return payload;
//   };

//   // ============================================
//   // SAVE HANDLER WITH DYNAMIC PAYLOAD
//   // ============================================
//   const handleSaveClick = async (request_status) => {
//     try {
//       // Clear previous errors
//       setErrors({});

//       // Step 1: Validate all required fields
//       const validationErrors = validateRequiredFields(request_status);

//       if (Object.keys(validationErrors).length > 0) {
//         setErrors(validationErrors);
//         setSeverity("error");
//         showSnackbar("Please fill all required fields");

//         // Scroll to first error
//         const firstErrorField = Object.keys(validationErrors)[0];
//         const errorElement = document.querySelector(
//           `[name="${firstErrorField}"]`,
//         );
//         if (errorElement) {
//           errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
//         }

//         return;
//       }

//       // Step 2: Build dynamic payload
//       const payload = buildDynamicPayload(request_status);

//       // Step 3: Log payload for debugging
//       console.log("=== DYNAMIC PAYLOAD ===");
//       console.log(JSON.stringify(payload, null, 2));
//       console.log("======================");

//       // Step 4: Submit to API
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.post(
//         `${API_URL}/api/add_permit_with_work_details`,
//         payload,
//         {
//           headers: {
//             Authorization: authKey,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       if (response.status === 201) {
//         setSeverity("success");
//         const message =
//           request_status === "Draft"
//             ? "Permit saved as draft successfully."
//             : "Permit request submitted successfully.";
//         showSnackbar(message);

//         setTimeout(() => {
//           navigate(`/permit-requests`);
//         }, 1000);
//       } else {
//         throw new Error(
//           response.data.message || "Failed to save permit details.",
//         );
//       }
//     } catch (error) {
//       console.error("Error saving permit details:", error);
//       setSeverity("error");

//       const errorMessage =
//         error.response?.data?.message ||
//         error.message ||
//         "An error occurred while saving permit details.";

//       showSnackbar(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Snackbar functions
//   const showSnackbar = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   // Cancel handler
//   const handleCancelClick = () => {
//     navigate("/permit-requests");
//   };

//   // Fetch permit types
//   const fetchPermitType = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/get_work_permit_types`, {
//         headers: {
//           Authorization: authKey,
//         },
//       });

//       const permitTypeOptions = response.data.work_permit_types.map(
//         (permitType) => ({
//           value: permitType.id,
//           label: permitType.work_permit_name,
//         }),
//       );

//       setPermitType(permitTypeOptions);
//     } catch (error) {
//       console.error("Error fetching permit types:", error.message);
//       setSeverity("error");
//       showSnackbar("Failed to load permit types");
//     }
//   };

//   // Handle permit type change
//   const handlePermitTypeChange = async (selectedOption) => {
//     console.log("selectedOption", selectedOption);
//     setSelectedPermitType(selectedOption);
//     setFormData((prevState) => ({
//       ...prevState,
//       permit_type_id: selectedOption ? selectedOption.value : "",
//     }));

//     // Clear errors when permit type changes
//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       selectedPermitType: "",
//     }));

//     if (selectedOption) {
//       try {
//         const authKey = localStorage.getItem("authKey");

//         // Get permit fields
//         const response = await axios.get(
//           `${API_URL}/api/get_permit_fields/${selectedOption.value}`,
//           { headers: { Authorization: authKey } },
//         );

//         if (response.status === 200) {
//           const fields = response.data.fields;
//           setFields(fields);
//           console.log("Fields loaded:", fields);

//           // Fetch data for dropdown fields
//           const dropdownFields = fields.filter(
//             (field) => field.field_type === "dropdown" && field.api_endpoint,
//           );

//           const optionsData = {};
//           await Promise.all(
//             dropdownFields.map(async (field) => {
//               try {
//                 const dropdownResponse = await axios.get(
//                   `${API_URL}/${field.api_endpoint}`,
//                   { headers: { Authorization: authKey } },
//                 );

//                 const responseData = dropdownResponse.data;
//                 optionsData[field.id] = Array.isArray(responseData)
//                   ? responseData.map((item) => ({
//                       value: item.ID,
//                       label:
//                         item.DepartmentName ||
//                         item.TagNo ||
//                         item.Category ||
//                         "Unknown",
//                     }))
//                   : responseData.Items?.map((item) => ({
//                       value: item.ID,
//                       label: item.TagNo || item.Category || "Unknown",
//                     })) || [];
//               } catch (error) {
//                 console.error(
//                   `Error fetching options for ${field.field_label}:`,
//                   error,
//                 );
//               }
//             }),
//           );

//           setDropdownOptions(optionsData);
//           console.log("Dropdown options loaded:", optionsData);
//         }

//         // Fetch the dynamic endpoint
//         const endpointResponse = await axios.get(
//           `${API_URL}/api/get_permit_api_endpoints/${selectedOption.value}`,
//           { headers: { Authorization: authKey } },
//         );

//         if (
//           endpointResponse.status === 200 &&
//           endpointResponse.data.endpoints.length > 0
//         ) {
//           const postEndpoint = endpointResponse.data.endpoints.find(
//             (e) => e.method === "POST",
//           );
//           if (postEndpoint) {
//             setDynamicApiEndpoint(postEndpoint.api_endpoint);
//           }
//         }
//       } catch (error) {
//         console.error(
//           "Error fetching permit fields or API endpoint:",
//           error.message,
//         );
//         setSeverity("error");
//         showSnackbar("Failed to load permit configuration");
//       }
//     } else {
//       // Clear fields when no permit type is selected
//       setFields([]);
//       setDynamicSubFields([]);
//       setDropdownOptions({});
//       setSelectedOptions({});
//     }
//   };

//   // ============================================
//   // UPDATED clearFieldError FUNCTION
//   // ============================================
//   const clearFieldError = (fieldName) => {
//     if (errors[fieldName] || errors.department_id) {
//       setErrors((prevErrors) => {
//         const newErrors = { ...prevErrors };
//         delete newErrors[fieldName];

//         // Also clear department_id error when department field is modified
//         if (fieldName === "department_name" && newErrors.department_id) {
//           delete newErrors.department_id;
//         }

//         return newErrors;
//       });
//     }
//   };

//   // Initialize component
//   useEffect(() => {
//     fetchPermitType();
//   }, []);

//   return (
//     <>
//       <div
//         className={`data-form-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-form-content">
//           <div className="data-form-header">
//             <div className="data-form-header-content">
//               <PageBackTitle className="data-form-heading-content-left-side">//                 New Work Permit Request
//</PageBackTitle>
//               <div className="data-form-heading-content-right-side"></div>
//             </div>
//           </div>
//           <div className="header-separator"></div>
//           <div className="data-form-body">
//             <form className="form-detail">
//               <div className="new-data-form">
//                 {/* Permit Type Selection */}
//                 <div className="form-group-select">
//                   <label htmlFor="form_type">
//                     Permit Type<span className="text-danger">*</span>
//                   </label>
//                   <Select
//                     id="form_type"
//                     options={permitType}
//                     value={selectedPermitType}
//                     onChange={handlePermitTypeChange}
//                     placeholder="Select permit type"
//                   />
//                   {errors.selectedPermitType && (
//                     <div className="error-message">
//                       {errors.selectedPermitType}
//                     </div>
//                   )}
//                 </div>

//                 {/* Dynamic Fields Container */}
//                 <div className="permit-fields-container">
//                   {fields?.length > 0 &&
//                     fields.map((field) => {
//                       const isIssuedToField = field.field_name === "issued_to";

//                       return (
//                         <div key={field.id} className="form-group">
//                           <label>
//                             {field.field_label}
//                             {Number(field.is_required) === 1 && (
//                               <span className="text-danger">*</span>
//                             )}
//                           </label>

//                           {isIssuedToField ? (
//                             <div className="wp-dflex-div">
//                               <div className="">
//                                 <Select
//                                   className="full-width-select-wp"
//                                   options={field.options.map((opt) => ({
//                                     label: opt,
//                                     value: opt,
//                                   }))}
//                                   value={
//                                     formData.issued_to
//                                       ? {
//                                           value: formData.issued_to,
//                                           label: formData.issued_to,
//                                         }
//                                       : null
//                                   }
//                                   onChange={async (selected) => {
//                                     const value = selected
//                                       ? selected.value
//                                       : "";

//                                     setFormData((prev) => ({
//                                       ...prev,
//                                       issued_to: value,
//                                       // Clear department_id when issued_to changes
//                                       department_id: "",
//                                     }));

//                                     // Clear errors for issued_to field
//                                     setErrors((prevErrors) => {
//                                       const newErrors = { ...prevErrors };
//                                       delete newErrors[field.field_name];
//                                       delete newErrors.issued_to;
//                                       return newErrors;
//                                     });

//                                     if (value) {
//                                       try {
//                                         const authKey =
//                                           localStorage.getItem("authKey");

//                                         // Fetch dependent fields
//                                         const response = await axios.get(
//                                           `${API_URL}/api/dependent_fields`,
//                                           {
//                                             headers: { Authorization: authKey },
//                                             params: {
//                                               permit_type_id:
//                                                 selectedPermitType?.value,
//                                               controller_field_id: field.id,
//                                               controller_value: value,
//                                             },
//                                           },
//                                         );

//                                         let fetchedSubFields =
//                                           response.data.fields || [];

//                                         // For each subField, if options_source === "api", fetch options
//                                         for (const subField of fetchedSubFields) {
//                                           if (
//                                             subField.options_source === "api" &&
//                                             subField.api_endpoint
//                                           ) {
//                                             const subOptionsRes =
//                                               await axios.get(
//                                                 `${API_URL}/${subField.api_endpoint}`,
//                                                 {
//                                                   headers: {
//                                                     Authorization: authKey,
//                                                   },
//                                                 },
//                                               );
//                                             console.log(
//                                               "Sub options loaded:",
//                                               subOptionsRes.data,
//                                             );
//                                             subField.options =
//                                               subOptionsRes.data || [];
//                                           }
//                                         }

//                                         console.log(
//                                           "Resolved dependent fields:",
//                                           fetchedSubFields,
//                                         );
//                                         setDynamicSubFields(fetchedSubFields);
//                                       } catch (error) {
//                                         console.error(
//                                           "Error fetching dependent fields:",
//                                           error,
//                                         );
//                                         setDynamicSubFields([]);
//                                       }
//                                     } else {
//                                       setDynamicSubFields([]);
//                                     }
//                                   }}
//                                   placeholder="Select issued to"
//                                   isClearable
//                                 />
//                               </div>

//                               <div
//                                 style={{ marginBottom: "0px" }}
//                                 className={
//                                   field.field_type === "dropdown"
//                                     ? "form-group-select"
//                                     : "form-group"
//                                 }
//                               >
//                                 {dynamicSubFields.map((subField) => (
//                                   <div
//                                     key={subField.id}
//                                     className={
//                                       subField.field_type === "dropdown"
//                                         ? "form-group-select"
//                                         : "form-group"
//                                     }
//                                   >
//                                     <label>
//                                       {subField.field_label}
//                                       {Number(subField.is_required) === 1 && (
//                                         <span className="text-danger">*</span>
//                                       )}
//                                     </label>

//                                     {subField.field_type === "dropdown" && (
//                                       <Select
//                                         className="full-width-select-wp"
//                                         options={(subField.options || []).map(
//                                           (opt) => ({
//                                             value: opt?.ID,
//                                             label:
//                                               opt?.DepartmentName ||
//                                               opt?.Name ||
//                                               opt?.label ||
//                                               "",
//                                           }),
//                                         )}
//                                         value={(() => {
//                                           // Check if this is a department field
//                                           const isDepartmentField =
//                                             subField.field_name ===
//                                             "department_name";
//                                           const storedValue = isDepartmentField
//                                             ? formData.department_id
//                                             : formData[subField.field_name];

//                                           return storedValue
//                                             ? {
//                                                 value: storedValue,
//                                                 label:
//                                                   formData[
//                                                     subField.field_label
//                                                   ] || "",
//                                               }
//                                             : null;
//                                         })()}
//                                         onChange={(selected) => {
//                                           console.log(
//                                             `${subField.field_label} selected:`,
//                                             selected,
//                                           );
//                                           const selectedId =
//                                             selected?.value || "";
//                                           const selectedLabel =
//                                             selected?.label || "";

//                                           // Update formData
//                                           setFormData((prev) => {
//                                             const updates = {
//                                               ...prev,
//                                               [subField.field_label]:
//                                                 selectedLabel,
//                                               [subField.field_name]: selectedId,
//                                             };

//                                             // If this is department field, also store as department_id
//                                             if (
//                                               subField.field_name ===
//                                               "department_name"
//                                             ) {
//                                               updates.department_id =
//                                                 selectedId;
//                                             }

//                                             return updates;
//                                           });

//                                           // Clear errors for this field
//                                           setErrors((prevErrors) => {
//                                             const newErrors = { ...prevErrors };
//                                             delete newErrors[
//                                               subField.field_name
//                                             ];

//                                             // Also clear department_id error if this is department field
//                                             if (
//                                               subField.field_name ===
//                                               "department_name"
//                                             ) {
//                                               delete newErrors.department_id;
//                                             }

//                                             return newErrors;
//                                           });
//                                         }}
//                                         placeholder={
//                                           subField.placeholder ||
//                                           `Select ${subField.field_label}`
//                                         }
//                                         isClearable
//                                       />
//                                     )}

//                                     {subField.field_type === "text" && (
//                                       <div className="input-group full-width-input-wp">
//                                         <input
//                                           className="full-width-input-wp"
//                                           type="text"
//                                           name={subField.field_name}
//                                           value={
//                                             formData[subField.field_name] || ""
//                                           }
//                                           onChange={(e) => {
//                                             setFormData((prev) => ({
//                                               ...prev,
//                                               [subField.field_name]:
//                                                 e.target.value,
//                                             }));
//                                             clearFieldError(
//                                               subField.field_name,
//                                             );
//                                           }}
//                                           placeholder={
//                                             subField.placeholder || ""
//                                           }
//                                         />
//                                       </div>
//                                     )}

//                                     {/* Error display for sub-fields */}
//                                     {(errors[subField.field_name] ||
//                                       (subField.field_name ===
//                                         "department_name" &&
//                                         errors.department_id)) && (
//                                       <div className="error-message">
//                                         {errors[subField.field_name] ||
//                                           errors.department_id}
//                                       </div>
//                                     )}
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <>
//                               {field.field_type === "dropdown" && (
//                                 <div className="input-group form-group-tag-no">
//                                   <Select
//                                     id={field.field_label}
//                                     isMulti={field.is_multiple}
//                                     options={
//                                       field.options_source === "api"
//                                         ? dropdownOptions[field.id] || []
//                                         : field.options.map((opt) => ({
//                                             value: opt,
//                                             label: opt,
//                                           }))
//                                     }
//                                     value={
//                                       selectedOptions[field.id] ||
//                                       (field.is_multiple ? [] : null)
//                                     }
//                                     onMenuOpen={async () => {
//                                       if (
//                                         field.options_source === "api" &&
//                                         !dropdownOptions[field.id]
//                                       ) {
//                                         try {
//                                           const authKey =
//                                             localStorage.getItem("authKey");
//                                           const response = await axios.get(
//                                             `${API_URL}/${field.api_endpoint}`,
//                                             {
//                                               headers: {
//                                                 Authorization: authKey,
//                                               },
//                                             },
//                                           );
//                                           const fetchedOptions =
//                                             response.data.options || [];
//                                           setDropdownOptions((prev) => ({
//                                             ...prev,
//                                             [field.id]: fetchedOptions.map(
//                                               (opt) => ({
//                                                 value: opt,
//                                                 label: opt,
//                                               }),
//                                             ),
//                                           }));
//                                         } catch (err) {
//                                           console.error(
//                                             "Failed to load dynamic options:",
//                                             err,
//                                           );
//                                         }
//                                       }
//                                     }}
//                                     onChange={(selected) => {
//                                       setSelectedOptions((prev) => ({
//                                         ...prev,
//                                         [field.id]: selected,
//                                       }));

//                                       clearFieldError(field.field_name);

//                                       if (
//                                         field.field_name === "equipment_ids"
//                                       ) {
//                                         setFormData((prev) => ({
//                                           ...prev,
//                                           equipment_ids: selected
//                                             ? selected.map((tag) => tag.value)
//                                             : [],
//                                         }));
//                                       }
//                                     }}
//                                     isSearchable
//                                     isClearable={!field.is_multiple}
//                                     placeholder={
//                                       field.placeholder || "Select option"
//                                     }
//                                     styles={{
//                                       container: (base) => ({
//                                         ...base,
//                                         width: "100%",
//                                       }),
//                                     }}
//                                   />

//                                   {field.is_multiple &&
//                                     selectedOptions[field.id]?.length > 0 && (
//                                       <Stack
//                                         direction="row"
//                                         spacing={1}
//                                         flexWrap="wrap"
//                                         className="chip-container"
//                                         sx={{ mt: 1 }}
//                                       >
//                                         {selectedOptions[field.id].map(
//                                           (tag) => (
//                                             <Chip
//                                               key={tag.value}
//                                               label={tag.label}
//                                               onDelete={() => {
//                                                 const updated = selectedOptions[
//                                                   field.id
//                                                 ].filter(
//                                                   (item) =>
//                                                     item.value !== tag.value,
//                                                 );
//                                                 setSelectedOptions((prev) => ({
//                                                   ...prev,
//                                                   [field.id]: updated,
//                                                 }));

//                                                 if (
//                                                   field.field_name ===
//                                                   "equipment_ids"
//                                                 ) {
//                                                   setFormData((prev) => ({
//                                                     ...prev,
//                                                     equipment_ids: updated.map(
//                                                       (item) => item.value,
//                                                     ),
//                                                   }));
//                                                 }
//                                               }}
//                                               color="primary"
//                                               variant="outlined"
//                                               sx={{ mb: 1 }}
//                                             />
//                                           ),
//                                         )}
//                                       </Stack>
//                                     )}
//                                 </div>
//                               )}

//                               {field.field_type === "text" && (
//                                 <div className="input-group">
//                                   <input
//                                     type="text"
//                                     name={field.field_name}
//                                     className="form-control"
//                                     value={formData[field.field_name] || ""}
//                                     required={Number(field.is_required) === 1}
//                                     placeholder={field.placeholder}
//                                     onChange={(e) => {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         [field.field_name]: e.target.value,
//                                       }));
//                                       clearFieldError(field.field_name);
//                                     }}
//                                   />
//                                 </div>
//                               )}

//                               {field.field_type === "checkbox" && (
//                                 <div className="permit_checkbox_group">
//                                   {[
//                                     "Excavation",
//                                     "Road Cutting",
//                                     "Road Closure",
//                                   ].map((option) => (
//                                     <label
//                                       key={option}
//                                       className="permit_checkbox-item"
//                                     >
//                                       <div className="checkbox_input">
//                                         <input
//                                           type="checkbox"
//                                           name={field.field_name}
//                                           value={option}
//                                           className="permit_small-checkbox"
//                                           checked={
//                                             formData[
//                                               field.field_name
//                                             ]?.includes(option) || false
//                                           }
//                                           required={
//                                             Number(field.is_required) === 1
//                                           }
//                                           onChange={(e) => {
//                                             const checked = e.target.checked;
//                                             setFormData((prev) => {
//                                               const currentValues =
//                                                 prev[field.field_name] || [];
//                                               return {
//                                                 ...prev,
//                                                 [field.field_name]: checked
//                                                   ? [...currentValues, option]
//                                                   : currentValues.filter(
//                                                       (val) => val !== option,
//                                                     ),
//                                               };
//                                             });
//                                             clearFieldError(field.field_name);
//                                           }}
//                                         />
//                                       </div>
//                                       <div className="checkbox_option">
//                                         {option}
//                                       </div>
//                                     </label>
//                                   ))}
//                                 </div>
//                               )}

//                               {field.field_type === "number" && (
//                                 <div className="input-group">
//                                   <input
//                                     type="number"
//                                     name={field.field_name}
//                                     className="form-control"
//                                     value={formData[field.field_name] || ""}
//                                     required={Number(field.is_required) === 1}
//                                     placeholder={field.placeholder}
//                                     onChange={(e) => {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         [field.field_name]: e.target.value,
//                                       }));
//                                       clearFieldError(field.field_name);
//                                     }}
//                                   />
//                                 </div>
//                               )}

//                               {field.field_type === "textarea" && (
//                                 <div className="input-group">
//                                   <textarea
//                                     name={field.field_name}
//                                     className="form-control"
//                                     value={formData[field.field_name] || ""}
//                                     required={Number(field.is_required) === 1}
//                                     placeholder={field.placeholder}
//                                     onChange={(e) => {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         [field.field_name]: e.target.value,
//                                       }));
//                                       clearFieldError(field.field_name);
//                                     }}
//                                   />
//                                 </div>
//                               )}

//                               {field.field_type === "date" && (
//                                 <div className="input-group">
//                                   <DatePicker
//                                     selected={
//                                       dateValues[field.field_label] || null
//                                     }
//                                     onChange={(date) => {
//                                       console.log("datedate", date);
//                                       setDateValues((prev) => {
//                                         const updated = {
//                                           ...prev,
//                                           [field.field_label]: date,
//                                         };

//                                         // Clear End Date if Start > End
//                                         if (
//                                           field.field_label ===
//                                             "Start Date & Time" &&
//                                           updated["End Date & Time"] &&
//                                           date > updated["End Date & Time"]
//                                         ) {
//                                           updated["End Date & Time"] = null;
//                                         }

//                                         return updated;
//                                       });

//                                       clearFieldError(field.field_label);
//                                       clearFieldError(field.field_name);
//                                     }}
//                                     showTimeSelect
//                                     dateFormat="dd/MM/yyyy hh:mm a"
//                                     className="form-control"
//                                     placeholderText={
//                                       field.placeholder || "Select date"
//                                     }
//                                     minDate={
//                                       field.field_label === "End Date & Time"
//                                         ? dateValues["Start Date & Time"] ||
//                                           new Date()
//                                         : new Date()
//                                     }
//                                     minTime={
//                                       field.field_label === "End Date & Time" &&
//                                       dateValues["Start Date & Time"] &&
//                                       dateValues["End Date & Time"] &&
//                                       new Date(
//                                         dateValues["Start Date & Time"],
//                                       ).toDateString() ===
//                                         new Date(
//                                           dateValues["End Date & Time"],
//                                         ).toDateString()
//                                         ? new Date(
//                                             dateValues["Start Date & Time"],
//                                           )
//                                         : setHours(setMinutes(new Date(), 0), 0)
//                                     }
//                                     maxTime={setHours(
//                                       setMinutes(new Date(), 59),
//                                       23,
//                                     )}
//                                     required={Number(field.is_required) === 1}
//                                   />
//                                 </div>
//                               )}
//                             </>
//                           )}

//                           {errors[field.field_name] && (
//                             <div className="error-message">
//                               {errors[field.field_name]}
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}
//                 </div>
//               </div>
//             </form>
//           </div>
//           <div className="footer">
//             <div className="button-group">
//               <button
//                 className="data-form-save-button"
//                 type="button"
//                 onClick={() => handleSaveClick("Draft")}
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Saving..." : "Save as Draft"}
//               </button>
//               <button
//                 className="request-button"
//                 type="button"
//                 onClick={() => handleSaveClick("Submitted")}
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Sending Request..." : "Send Request"}
//               </button>
//               <button
//                 className="data-form-cancel-button"
//                 type="button"
//                 onClick={handleCancelClick}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default PermitRequestForm;

// --------------------------- excavation code 1---------------------------

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Form.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { setHours, setMinutes } from "date-fns";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

const EXCAVATION_WORK_TYPE_OPTIONS = [
  "Excavation",
  "Road Cutting",
  "Road Closure",
];

const detectPermitCategory = (label = "") => {
  const normalized = label.toLowerCase();
  if (
    normalized.includes("excavation") ||
    normalized.includes("road closure")
  ) {
    return "excavation";
  }
  if (
    normalized.includes("isolation") ||
    normalized.includes("energisation")
  ) {
    return "isolation";
  }
  return "standard";
};

const getFirstNonEmptyValue = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) {
      continue;
    }

    if (typeof value === "string") {
      if (value.trim()) {
        return value.trim();
      }
      continue;
    }

    if (Array.isArray(value)) {
      if (value.length) {
        return value;
      }
      continue;
    }

    if (value !== "") {
      return value;
    }
  }

  return "";
};

const isIsolationEquipmentField = (fieldName = "") =>
  fieldName === "iso_equipment_number";

const mapEquipmentTagOptions = (responseData) => {
  const items = Array.isArray(responseData)
    ? responseData
    : Array.isArray(responseData?.Items)
      ? responseData.Items
      : [];

  return items
    .map((item) => {
      const tagValue = item?.TagNo || item?.equipment_no || item?.Category || "";

      if (!tagValue || tagValue === "0") {
        return null;
      }

      return {
        value: tagValue,
        label: tagValue,
      };
    })
    .filter(Boolean);
};

const getInitialFormData = () => ({
  section: "",
  department_id: "",
  form_id: "",
  area: "",
  equipment_no: "",
  issued_to: "",
  work_description: "",
  contractor: "",
  unit: "",
  location: "",
  valid_from: "",
  valid_to: "",
  receiver_name: "",
  permit_type_id: "",
  department: "",
  work_type: [],
  equipment_ids: [],
});

function PermitRequestForm({ isSidebarExpanded }) {
  // State declarations
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [permitType, setPermitType] = useState([]);
  const [selectedPermitType, setSelectedPermitType] = useState(null);
  const [permitCategory, setPermitCategory] = useState("standard");
  const [fields, setFields] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [dateValues, setDateValues] = useState({});
  const [dynamicSubFields, setDynamicSubFields] = useState([]);
  const [formData, setFormData] = useState(getInitialFormData);

  // ============================================
  // FULLY DYNAMIC VALIDATION FUNCTION
  // ============================================
  const validateRequiredFields = (request_status) => {
    const errors = {};

    // 1. Validate permit type selection (always required)
    if (!selectedPermitType?.value) {
      errors.selectedPermitType = "Permit Type is required";
    }

    // 2. Validate dynamic fields from permit type configuration
    fields.forEach((field) => {
      if (Number(field.is_required) === 1) {
        const fieldName = field.field_name;
        const fieldLabel = field.field_label;

        if (field.field_type === "dropdown") {
          if (field.is_multiple) {
            // Multi-select dropdown validation
            if (!selectedOptions[field.id]?.length) {
              errors[fieldName] = `${fieldLabel} is required`;
            }
          } else {
            // Single-select dropdown validation
            // Check both formData and selectedOptions
            const hasValueInFormData =
              formData[fieldName] && formData[fieldName] !== "";
            const hasValueInSelectedOptions = selectedOptions[field.id]?.value;

            if (!hasValueInFormData && !hasValueInSelectedOptions) {
              errors[fieldName] = `${fieldLabel} is required`;
            }
          }
        } else if (field.field_type === "date") {
          if (!dateValues[fieldLabel]) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else if (field.field_type === "checkbox") {
          const checkboxValues = formData[fieldName];
          if (
            !checkboxValues ||
            (Array.isArray(checkboxValues) && checkboxValues.length === 0)
          ) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else {
          // Text, number, textarea validation
          const value = formData[fieldName];
          if (!value || (typeof value === "string" && !value.trim())) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        }
      }
    });

    // 3. Validate dynamic sub-fields (dependent fields based on parent selection)
    dynamicSubFields.forEach((subField) => {
      if (Number(subField.is_required) === 1) {
        const fieldName = subField.field_name;
        const fieldLabel = subField.field_label;

        if (subField.field_type === "dropdown") {
          // For department dropdown, check department_id instead of department_name
          if (fieldName === "department_name") {
            if (!formData.department_id || formData.department_id === "") {
              errors.department_id = `${fieldLabel} is required`;
            }
          } else {
            // For other dropdowns, check the field value
            if (!formData[fieldName] || formData[fieldName] === "") {
              errors[fieldName] = `${fieldLabel} is required`;
            }
          }
        } else if (subField.field_type === "date") {
          if (!dateValues[fieldLabel]) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else if (subField.field_type === "checkbox") {
          const checkboxValues = formData[fieldName];
          if (
            !checkboxValues ||
            (Array.isArray(checkboxValues) && checkboxValues.length === 0)
          ) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else {
          const value = formData[fieldName];
          if (!value || (typeof value === "string" && !value.trim())) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        }
      }
    });

    // 4. Validate date range if both dates exist
    const startDateField = fields.find(
      (f) => f.field_label === "Start Date & Time",
    );
    const endDateField = fields.find(
      (f) => f.field_label === "End Date & Time",
    );

    if (startDateField && endDateField) {
      const startDate = dateValues[startDateField.field_label];
      const endDate = dateValues[endDateField.field_label];

      if (startDate && endDate && startDate >= endDate) {
        errors[endDateField.field_name] = "End date must be after start date";
      }
    }

    return errors;
  };

  // ============================================
  // FULLY DYNAMIC PAYLOAD BUILDER
  // ============================================
  const buildDynamicPayload = (request_status) => {
    const payload = {
      // Core system fields
      permit_type_id: selectedPermitType?.value,
      request_status,
    };

    // Process all dynamic fields from permit type configuration
    fields.forEach((field) => {
      const fieldName = field.field_name;
      const fieldLabel = field.field_label;

      switch (field.field_type) {
        case "dropdown":
          if (field.is_multiple) {
            // Multi-select: array of IDs
            payload[fieldName] = selectedOptions[field.id]
              ? selectedOptions[field.id].map((item) => item.value)
              : [];
          } else {
            // Single-select: single ID or empty string
            // Check if value is stored in formData (for issued_to and similar fields)
            if (formData[fieldName]) {
              payload[fieldName] = formData[fieldName];
            } else if (selectedOptions[field.id]) {
              payload[fieldName] = selectedOptions[field.id].value;
            } else {
              payload[fieldName] = "";
            }
          }
          break;

        case "date":
          // Date fields with time
          if (dateValues[fieldLabel]) {
            payload[fieldName] = format(
              dateValues[fieldLabel],
              "yyyy-MM-dd HH:mm:ss",
            );
          } else {
            payload[fieldName] = null;
          }
          break;

        case "checkbox":
          // Checkbox: always an array
          const checkboxValues = formData[fieldName];
          if (Array.isArray(checkboxValues)) {
            payload[fieldName] = checkboxValues;
          } else if (checkboxValues) {
            payload[fieldName] = [checkboxValues];
          } else {
            payload[fieldName] = [];
          }
          break;

        case "number":
          // Convert to number or null
          const numValue = formData[fieldName];
          payload[fieldName] =
            numValue && numValue !== "" ? Number(numValue) : null;
          break;

        default:
          // Text, textarea, etc.
          const textValue = formData[fieldName];
          payload[fieldName] =
            textValue && typeof textValue === "string"
              ? textValue.trim()
              : textValue || "";
      }
    });

    // Process dynamic sub-fields (dependent fields)
    dynamicSubFields.forEach((subField) => {
      const fieldName = subField.field_name;
      const fieldLabel = subField.field_label;

      switch (subField.field_type) {
        case "dropdown":
          // Special case: For department field, use department_id instead of department_name
          if (fieldName === "department_name") {
            // Pass department_id in payload, not department_name
            payload["department_id"] = formData.department_id || "";
          } else {
            // For other dropdowns, use the field value directly
            payload[fieldName] = formData[fieldName] || "";
          }
          break;

        case "date":
          if (dateValues[fieldLabel]) {
            payload[fieldName] = format(
              dateValues[fieldLabel],
              "yyyy-MM-dd HH:mm:ss",
            );
          } else {
            payload[fieldName] = null;
          }
          break;

        case "checkbox":
          const checkboxValues = formData[fieldName];
          if (Array.isArray(checkboxValues)) {
            payload[fieldName] = checkboxValues;
          } else if (checkboxValues) {
            payload[fieldName] = [checkboxValues];
          } else {
            payload[fieldName] = [];
          }
          break;

        case "number":
          const numValue = formData[fieldName];
          payload[fieldName] =
            numValue && numValue !== "" ? Number(numValue) : null;
          break;

        default:
          // Text, textarea
          const textValue = formData[fieldName];
          payload[fieldName] =
            textValue && typeof textValue === "string"
              ? textValue.trim()
              : textValue || "";
      }
    });

    return payload;
  };

  const buildIsolationPayload = (payload) => {
    const requestDateTime = getFirstNonEmptyValue(
      payload.iso_request_datetime,
      payload.iso_request_date,
      payload.iso_request_time,
      payload.request_date_time,
      payload.request_datetime,
      payload.requested_at,
    );

    return {
      permit_type_id: payload.permit_type_id,
      department_id: getFirstNonEmptyValue(
        payload.department_id,
        payload.department,
      ),
      section: getFirstNonEmptyValue(payload.section),
      facility_location: getFirstNonEmptyValue(
        payload.facility_location,
        payload.location,
      ),
      iso_request_datetime: requestDateTime,
      iso_department_section: getFirstNonEmptyValue(
        payload.iso_department_section,
        payload.department_section,
        payload.department_section_area,
        payload.area,
      ),
      iso_equipment_number: getFirstNonEmptyValue(
        payload.iso_equipment_number,
        payload.equipment_number,
        payload.equipment_no,
      ),
      iso_equipment_circuit_name: getFirstNonEmptyValue(
        payload.iso_equipment_circuit_name,
        payload.equipment_circuit_name,
        payload.equipment_circuit_no,
      ),
      iso_maintenance_work_by: getFirstNonEmptyValue(
        payload.iso_maintenance_work_by,
        payload.maintenance_work_by,
        payload.issued_to,
      ),
      iso_requested_by_name: getFirstNonEmptyValue(
        payload.iso_requested_by_name,
        payload.requested_by_name,
        payload.receiver_name,
      ),
      iso_requested_by_designation: getFirstNonEmptyValue(
        payload.iso_requested_by_designation,
        payload.requested_by_designation,
        payload.designation,
      ),
    };
  };

  // ============================================
  // SAVE HANDLER WITH DYNAMIC PAYLOAD
  // ============================================
  const handleSaveClick = async (request_status) => {
    try {
      // Clear previous errors
      setErrors({});

      // Step 1: Validate all required fields
      const validationErrors = validateRequiredFields(request_status);

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setSeverity("error");
        showSnackbar("Please fill all required fields");

        // Scroll to first error
        const firstErrorField = Object.keys(validationErrors)[0];
        const errorElement = document.querySelector(
          `[name="${firstErrorField}"]`,
        );
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        return;
      }

      // Step 2: Build dynamic payload
      const payload = buildDynamicPayload(request_status);

      // Step 3: Submit to API
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      if (permitCategory === "isolation" && request_status === "Draft") {
        setSeverity("error");
        showSnackbar(
          "Isolation permit does not support draft save. Please send the request.",
        );
        return;
      }

      const requestConfig = {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
      };

      const response =
        permitCategory === "isolation"
          ? await axios.post(
              `${API_URL}/api/isolation_permit/create`,
              buildIsolationPayload(payload),
              requestConfig,
            )
          : await axios.post(
              `${API_URL}/api/add_permit_with_work_details`,
              payload,
              requestConfig,
            );

      if (response.status === 200 || response.status === 201) {
        setSeverity("success");
        const message =
          permitCategory === "isolation"
            ? response.data?.message || "Isolation permit created successfully."
            : request_status === "Draft"
              ? "Permit saved as draft successfully."
              : "Permit request submitted successfully.";
        showSnackbar(message);

        setTimeout(() => {
          if (permitCategory === "isolation" && response.data?.permit_id) {
            navigate(`/isolation-certificate/${response.data.permit_id}`);
            return;
          }

          navigate(`/permit-requests`);
        }, 1000);
      } else {
        throw new Error(
          response.data.message || "Failed to save permit details.",
        );
      }
    } catch (error) {
      console.error("Error saving permit details:", error);
      setSeverity("error");

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An error occurred while saving permit details.";

      showSnackbar(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  // Snackbar functions
  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  // Cancel handler
  const handleCancelClick = () => {
    navigate("/permit-requests");
  };

  const resetPermitState = (permitTypeId = "") => {
    setFields([]);
    setDropdownOptions({});
    setSelectedOptions({});
    setDateValues({});
    setDynamicSubFields([]);
    setErrors({});
    setPermitCategory("standard");
    setFormData({
      ...getInitialFormData(),
      permit_type_id: permitTypeId,
    });
  };

  const getExcavationWorkTypes = () =>
    Array.isArray(formData.work_type) ? formData.work_type : [];

  const handleExcavationWorkTypeChange = (option, checked) => {
    setFormData((prev) => {
      const current = Array.isArray(prev.work_type) ? prev.work_type : [];

      if (!checked) {
        return {
          ...prev,
          work_type: current.filter((value) => value !== option),
        };
      }

      if (option === "Road Closure") {
        return { ...prev, work_type: ["Road Closure"] };
      }

      if (current.includes("Road Closure")) {
        showSnackbar(
          "Road Closure must be selected alone. Please deselect it first.",
        );
        return prev;
      }

      if (current.includes(option)) {
        return prev;
      }

      return { ...prev, work_type: [...current, option] };
    });

    clearFieldError("work_type");
  };

  const getWorkTypeDisabled = (option) => {
    const current = getExcavationWorkTypes();

    if (option === "Road Closure") {
      return current.includes("Excavation") || current.includes("Road Cutting");
    }

    if (option === "Excavation" || option === "Road Cutting") {
      return current.includes("Road Closure");
    }

    return false;
  };

  const getCheckboxOptions = (field) => {
    if (
      permitCategory === "excavation" &&
      field.field_name === "work_type" &&
      !(field.options || []).length
    ) {
      return EXCAVATION_WORK_TYPE_OPTIONS;
    }

    return field.options || [];
  };

  // Fetch permit types
  const fetchPermitType = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_work_permit_types`, {
        headers: {
          Authorization: authKey,
        },
      });

      const permitTypeOptions = response.data.work_permit_types.map(
        (permitType) => ({
          value: permitType.id,
          label: permitType.work_permit_name,
        }),
      );

      setPermitType(permitTypeOptions);
    } catch (error) {
      console.error("Error fetching permit types:", error.message);
      setSeverity("error");
      showSnackbar("Failed to load permit types");
    }
  };

  // Handle permit type change
  const handlePermitTypeChange = async (selectedOption) => {
    setSelectedPermitType(selectedOption);
    const permitTypeId = selectedOption ? selectedOption.value : "";
    resetPermitState(permitTypeId);

    // Clear errors when permit type changes
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedPermitType: "",
    }));

    if (selectedOption) {
      try {
        const authKey = localStorage.getItem("authKey");
        const category = detectPermitCategory(selectedOption.label);
        setPermitCategory(category);

        // Get permit fields
        const response = await axios.get(
          `${API_URL}/api/get_permit_fields/${selectedOption.value}`,
          { headers: { Authorization: authKey } },
        );

        if (response.status === 200) {
          const fields = response.data.fields;
          setFields(fields);

          // Fetch data for dropdown fields
          const dropdownFields = fields.filter(
            (field) =>
              shouldRenderAsDropdown(field, category) &&
              (field.api_endpoint || isIsolationEquipmentField(field.field_name)),
          );

          const optionsData = {};
          await Promise.all(
            dropdownFields.map(async (field) => {
              try {
                if (isIsolationEquipmentField(field.field_name)) {
                  const dropdownResponse = await axios.get(
                    `${API_URL}/api/get_equipment_tag_no`,
                    { headers: { Authorization: authKey } },
                  );

                  optionsData[field.id] = mapEquipmentTagOptions(
                    dropdownResponse.data,
                  );
                  return;
                }

                const dropdownResponse = await axios.get(
                  `${API_URL}/${field.api_endpoint}`,
                  { headers: { Authorization: authKey } },
                );

                const responseData = dropdownResponse.data;
                optionsData[field.id] = Array.isArray(responseData)
                  ? responseData.map((item) => ({
                      value: item.ID,
                      label:
                        item.DepartmentName ||
                        item.TagNo ||
                        item.Category ||
                        "Unknown",
                    }))
                  : responseData.Items?.map((item) => ({
                      value: item.ID,
                      label: item.TagNo || item.Category || "Unknown",
                    })) || [];
              } catch (error) {
                console.error(
                  `Error fetching options for ${field.field_label}:`,
                  error,
                );
              }
            }),
          );

          setDropdownOptions(optionsData);
        }
      } catch (error) {
        console.error(
          "Error fetching permit fields or API endpoint:",
          error.message,
        );
        setSeverity("error");
        showSnackbar("Failed to load permit configuration");
      }
    } else {
      // Clear fields when no permit type is selected
      resetPermitState();
    }
  };

  // ============================================
  // UPDATED clearFieldError FUNCTION
  // ============================================
  const clearFieldError = (fieldName) => {
    if (errors[fieldName] || errors.department_id) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName];

        // Also clear department_id error when department field is modified
        if (fieldName === "department_name" && newErrors.department_id) {
          delete newErrors.department_id;
        }

        return newErrors;
      });
    }
  };

  const shouldRenderAsDropdown = (field, category = permitCategory) =>
    field?.field_type === "dropdown" ||
    (category === "isolation" &&
      isIsolationEquipmentField(field?.field_name));

  const getSingleSelectValue = (field) => {
    const selectedOption = selectedOptions[field.id];
    if (selectedOption) {
      return selectedOption;
    }

    const storedValue = formData[field.field_name];
    if (
      storedValue === null ||
      storedValue === undefined ||
      storedValue === "" ||
      storedValue === 0 ||
      storedValue === "0"
    ) {
      return null;
    }

    const matchedOption = (dropdownOptions[field.id] || []).find(
      (option) => String(option.value) === String(storedValue),
    );

    return (
      matchedOption || {
        value: storedValue,
        label: String(storedValue),
      }
    );
  };

  // Initialize component
  useEffect(() => {
    fetchPermitType();
  }, []);

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New Work Permit Request</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail">
              <div className="new-data-form">
                {/* Permit Type Selection */}
                <div className="form-group-select">
                  <label htmlFor="form_type">
                    Permit Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="form_type"
                    options={permitType}
                    value={selectedPermitType}
                    onChange={handlePermitTypeChange}
                    placeholder="Select permit type"
                  />
                  {errors.selectedPermitType && (
                    <div className="error-message">
                      {errors.selectedPermitType}
                    </div>
                  )}
                </div>

                {/* Dynamic Fields Container */}
                <div className="permit-fields-container">
                  {fields?.length > 0 &&
                    fields.map((field) => {
                      const isIssuedToField = field.field_name === "issued_to";
                      const isSelectField = shouldRenderAsDropdown(field);

                      return (
                        <div
                          key={field.id}
                          className={isSelectField ? "form-group-select" : "form-group"}
                        >
                          <label>
                            {field.field_label}
                            {Number(field.is_required) === 1 && (
                              <span className="text-danger">*</span>
                            )}
                          </label>

                          {isIssuedToField ? (
                            <div className="wp-dflex-div">
                              <div className="">
                                <Select
                                  className="full-width-select-wp"
                                  options={field.options.map((opt) => ({
                                    label: opt,
                                    value: opt,
                                  }))}
                                  value={
                                    formData.issued_to
                                      ? {
                                          value: formData.issued_to,
                                          label: formData.issued_to,
                                        }
                                      : null
                                  }
                                  onChange={async (selected) => {
                                    const value = selected
                                      ? selected.value
                                      : "";

                                    setFormData((prev) => ({
                                      ...prev,
                                      issued_to: value,
                                      // Clear department_id when issued_to changes
                                      department_id: "",
                                    }));

                                    // Clear errors for issued_to field
                                    setErrors((prevErrors) => {
                                      const newErrors = { ...prevErrors };
                                      delete newErrors[field.field_name];
                                      delete newErrors.issued_to;
                                      return newErrors;
                                    });

                                    if (value) {
                                      try {
                                        const authKey =
                                          localStorage.getItem("authKey");

                                        // Fetch dependent fields
                                        const response = await axios.get(
                                          `${API_URL}/api/dependent_fields`,
                                          {
                                            headers: { Authorization: authKey },
                                            params: {
                                              permit_type_id:
                                                selectedPermitType?.value,
                                              controller_field_id: field.id,
                                              controller_value: value,
                                            },
                                          },
                                        );

                                        let fetchedSubFields =
                                          response.data.fields || [];

                                        // For each subField, if options_source === "api", fetch options
                                        for (const subField of fetchedSubFields) {
                                          if (
                                            subField.options_source === "api" &&
                                            subField.api_endpoint
                                          ) {
                                            const subOptionsRes =
                                              await axios.get(
                                                `${API_URL}/${subField.api_endpoint}`,
                                                {
                                                  headers: {
                                                    Authorization: authKey,
                                                  },
                                                },
                                              );
                                            console.log(
                                              "Sub options loaded:",
                                              subOptionsRes.data,
                                            );
                                            subField.options =
                                              subOptionsRes.data || [];
                                          }
                                        }

                                        setDynamicSubFields(fetchedSubFields);
                                      } catch (error) {
                                        console.error(
                                          "Error fetching dependent fields:",
                                          error,
                                        );
                                        setDynamicSubFields([]);
                                      }
                                    } else {
                                      setDynamicSubFields([]);
                                    }
                                  }}
                                  placeholder="Select issued to"
                                  isClearable
                                />
                              </div>

                              <div
                                style={{ marginBottom: "0px" }}
                                className={
                                  field.field_type === "dropdown"
                                    ? "form-group-select"
                                    : "form-group"
                                }
                              >
                                {dynamicSubFields.map((subField) => (
                                  <div
                                    key={subField.id}
                                    className={
                                      subField.field_type === "dropdown"
                                        ? "form-group-select"
                                        : "form-group"
                                    }
                                  >
                                    <label>
                                      {subField.field_label}
                                      {Number(subField.is_required) === 1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {subField.field_type === "dropdown" && (
                                      <Select
                                        className="full-width-select-wp"
                                        options={(subField.options || []).map(
                                          (opt) => ({
                                            value: opt?.ID,
                                            label:
                                              opt?.DepartmentName ||
                                              opt?.Name ||
                                              opt?.label ||
                                              "",
                                          }),
                                        )}
                                        value={(() => {
                                          // Check if this is a department field
                                          const isDepartmentField =
                                            subField.field_name ===
                                            "department_name";
                                          const storedValue = isDepartmentField
                                            ? formData.department_id
                                            : formData[subField.field_name];

                                          return storedValue
                                            ? {
                                                value: storedValue,
                                                label:
                                                  formData[
                                                    subField.field_label
                                                  ] || "",
                                              }
                                            : null;
                                        })()}
                                        onChange={(selected) => {
                                          console.log(
                                            `${subField.field_label} selected:`,
                                            selected,
                                          );
                                          const selectedId =
                                            selected?.value || "";
                                          const selectedLabel =
                                            selected?.label || "";

                                          // Update formData
                                          setFormData((prev) => {
                                            const updates = {
                                              ...prev,
                                              [subField.field_label]:
                                                selectedLabel,
                                              [subField.field_name]: selectedId,
                                            };

                                            // If this is department field, also store as department_id
                                            if (
                                              subField.field_name ===
                                              "department_name"
                                            ) {
                                              updates.department_id =
                                                selectedId;
                                            }

                                            return updates;
                                          });

                                          // Clear errors for this field
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors };
                                            delete newErrors[
                                              subField.field_name
                                            ];

                                            // Also clear department_id error if this is department field
                                            if (
                                              subField.field_name ===
                                              "department_name"
                                            ) {
                                              delete newErrors.department_id;
                                            }

                                            return newErrors;
                                          });
                                        }}
                                        placeholder={
                                          subField.placeholder ||
                                          `Select ${subField.field_label}`
                                        }
                                        isClearable
                                      />
                                    )}

                                    {subField.field_type === "text" && (
                                      <div className="input-group full-width-input-wp">
                                        <input
                                          className="full-width-input-wp"
                                          type="text"
                                          name={subField.field_name}
                                          value={
                                            formData[subField.field_name] || ""
                                          }
                                          onChange={(e) => {
                                            setFormData((prev) => ({
                                              ...prev,
                                              [subField.field_name]:
                                                e.target.value,
                                            }));
                                            clearFieldError(
                                              subField.field_name,
                                            );
                                          }}
                                          placeholder={
                                            subField.placeholder || ""
                                          }
                                        />
                                      </div>
                                    )}

                                    {/* Error display for sub-fields */}
                                    {(errors[subField.field_name] ||
                                      (subField.field_name ===
                                        "department_name" &&
                                        errors.department_id)) && (
                                      <div className="error-message">
                                        {errors[subField.field_name] ||
                                          errors.department_id}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <>
                              {isSelectField && (
                                <div className="input-group form-group-tag-no">
                                  <Select
                                    className="full-width-select-wp"
                                    id={field.field_label}
                                    isMulti={
                                      field.is_multiple &&
                                      !isIsolationEquipmentField(field.field_name)
                                    }
                                    options={
                                      isIsolationEquipmentField(field.field_name)
                                        ? dropdownOptions[field.id] || []
                                        : field.options_source === "api"
                                        ? dropdownOptions[field.id] || []
                                        : field.options.map((opt) => ({
                                            value: opt,
                                            label: opt,
                                          }))
                                    }
                                    value={
                                      field.is_multiple &&
                                      !isIsolationEquipmentField(field.field_name)
                                        ? selectedOptions[field.id] || []
                                        : getSingleSelectValue(field)
                                    }
                                    onMenuOpen={async () => {
                                      if (
                                        !isIsolationEquipmentField(field.field_name) &&
                                        field.options_source === "api" &&
                                        !dropdownOptions[field.id]
                                      ) {
                                        try {
                                          const authKey =
                                            localStorage.getItem("authKey");
                                          const response = await axios.get(
                                            `${API_URL}/${field.api_endpoint}`,
                                            {
                                              headers: {
                                                Authorization: authKey,
                                              },
                                            },
                                          );
                                          const fetchedOptions =
                                            response.data.options || [];
                                          setDropdownOptions((prev) => ({
                                            ...prev,
                                            [field.id]: fetchedOptions.map(
                                              (opt) => ({
                                                value: opt,
                                                label: opt,
                                              }),
                                            ),
                                          }));
                                        } catch (err) {
                                          console.error(
                                            "Failed to load dynamic options:",
                                            err,
                                          );
                                        }
                                      }
                                    }}
                                    onChange={(selected) => {
                                      setSelectedOptions((prev) => ({
                                        ...prev,
                                        [field.id]: selected,
                                      }));

                                      clearFieldError(field.field_name);

                                      if (
                                        isIsolationEquipmentField(field.field_name)
                                      ) {
                                        setFormData((prev) => ({
                                          ...prev,
                                          [field.field_name]:
                                            selected?.value || "",
                                        }));
                                        return;
                                      }

                                      if (
                                        field.field_name === "equipment_ids"
                                      ) {
                                        setFormData((prev) => ({
                                          ...prev,
                                          equipment_ids: selected
                                            ? selected.map((tag) => tag.value)
                                            : [],
                                        }));
                                      }
                                    }}
                                    isSearchable
                                    isClearable={!field.is_multiple}
                                    placeholder={
                                      field.placeholder || "Select option"
                                    }
                                    styles={{
                                      container: (base) => ({
                                        ...base,
                                        width: "100%",
                                      }),
                                    }}
                                  />

                                  {Boolean(field.is_multiple) &&
                                    !isIsolationEquipmentField(field.field_name) &&
                                    selectedOptions[field.id]?.length > 0 && (
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        flexWrap="wrap"
                                        className="chip-container"
                                        sx={{ mt: 1 }}
                                      >
                                        {selectedOptions[field.id].map(
                                          (tag) => (
                                            <Chip
                                              key={tag.value}
                                              label={tag.label}
                                              onDelete={() => {
                                                const updated = selectedOptions[
                                                  field.id
                                                ].filter(
                                                  (item) =>
                                                    item.value !== tag.value,
                                                );
                                                setSelectedOptions((prev) => ({
                                                  ...prev,
                                                  [field.id]: updated,
                                                }));

                                                if (
                                                  field.field_name ===
                                                  "equipment_ids"
                                                ) {
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    equipment_ids: updated.map(
                                                      (item) => item.value,
                                                    ),
                                                  }));
                                                }
                                              }}
                                              color="primary"
                                              variant="outlined"
                                              sx={{ mb: 1 }}
                                            />
                                          ),
                                        )}
                                      </Stack>
                                    )}
                                </div>
                              )}

                              {field.field_type === "text" && !isSelectField && (
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name={field.field_name}
                                    className="form-control"
                                    value={formData[field.field_name] || ""}
                                    required={Number(field.is_required) === 1}
                                    placeholder={field.placeholder}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        [field.field_name]: e.target.value,
                                      }));
                                      clearFieldError(field.field_name);
                                    }}
                                  />
                                </div>
                              )}

                              {field.field_type === "checkbox" && (
                                <div
                                  className={`permit_checkbox_group${
                                    permitCategory === "excavation" &&
                                    field.field_name === "work_type"
                                      ? " permit-work-type-options"
                                      : ""
                                  }`}
                                >
                                  {getCheckboxOptions(field).map((option) => {
                                    const optionValue =
                                      typeof option === "string"
                                        ? option
                                        : option.value || option;
                                    const checkboxValues = Array.isArray(
                                      formData[field.field_name],
                                    )
                                      ? formData[field.field_name]
                                      : [];
                                    const isExcavationWorkTypeField =
                                      permitCategory === "excavation" &&
                                      field.field_name === "work_type";
                                    const isChecked =
                                      checkboxValues.includes(optionValue);
                                    const isDisabled = isExcavationWorkTypeField
                                      ? getWorkTypeDisabled(optionValue)
                                      : false;

                                    return (
                                      <label
                                        key={optionValue}
                                        className="permit_checkbox-item"
                                        style={
                                          isDisabled
                                            ? {
                                                opacity: 0.5,
                                                cursor: "not-allowed",
                                              }
                                            : undefined
                                        }
                                      >
                                        <div className="checkbox_input">
                                          <input
                                            type="checkbox"
                                            name={field.field_name}
                                            value={optionValue}
                                            className="permit_small-checkbox"
                                            checked={isChecked}
                                            disabled={isDisabled}
                                            required={
                                              Number(field.is_required) === 1
                                            }
                                            onChange={(e) => {
                                              if (isExcavationWorkTypeField) {
                                                handleExcavationWorkTypeChange(
                                                  optionValue,
                                                  e.target.checked,
                                                );
                                                return;
                                              }

                                              const checked = e.target.checked;
                                              setFormData((prev) => {
                                                const currentValues =
                                                  Array.isArray(
                                                    prev[field.field_name],
                                                  )
                                                    ? prev[field.field_name]
                                                    : [];
                                                return {
                                                  ...prev,
                                                  [field.field_name]: checked
                                                    ? [
                                                        ...currentValues,
                                                        optionValue,
                                                      ]
                                                    : currentValues.filter(
                                                        (val) =>
                                                          val !== optionValue,
                                                      ),
                                                };
                                              });
                                              clearFieldError(field.field_name);
                                            }}
                                          />
                                        </div>
                                        <div className="checkbox_option">
                                          {optionValue}
                                        </div>
                                      </label>
                                    );
                                  })}
                                </div>
                              )}

                              {field.field_type === "number" && (
                                <div className="input-group">
                                  <input
                                    type="number"
                                    name={field.field_name}
                                    className="form-control"
                                    value={formData[field.field_name] || ""}
                                    required={Number(field.is_required) === 1}
                                    placeholder={field.placeholder}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        [field.field_name]: e.target.value,
                                      }));
                                      clearFieldError(field.field_name);
                                    }}
                                  />
                                </div>
                              )}

                              {field.field_type === "textarea" && (
                                <div className="input-group">
                                  <textarea
                                    name={field.field_name}
                                    className="form-control"
                                    value={formData[field.field_name] || ""}
                                    required={Number(field.is_required) === 1}
                                    placeholder={field.placeholder}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        [field.field_name]: e.target.value,
                                      }));
                                      clearFieldError(field.field_name);
                                    }}
                                  />
                                </div>
                              )}

                              {field.field_type === "date" && (
                                <div className="input-group">
                                  <DatePicker
                                    selected={
                                      dateValues[field.field_label] || null
                                    }
                                    onChange={(date) => {
                                      setDateValues((prev) => {
                                        const updated = {
                                          ...prev,
                                          [field.field_label]: date,
                                        };

                                        // Clear End Date if Start > End
                                        if (
                                          field.field_label ===
                                            "Start Date & Time" &&
                                          updated["End Date & Time"] &&
                                          date > updated["End Date & Time"]
                                        ) {
                                          updated["End Date & Time"] = null;
                                        }

                                        return updated;
                                      });

                                      clearFieldError(field.field_label);
                                      clearFieldError(field.field_name);
                                    }}
                                    showTimeSelect
                                    dateFormat="dd/MM/yyyy hh:mm a"
                                    className="form-control"
                                    placeholderText={
                                      field.placeholder || "Select date"
                                    }
                                    minDate={
                                      field.field_label === "End Date & Time"
                                        ? dateValues["Start Date & Time"] ||
                                          new Date()
                                        : new Date()
                                    }
                                    minTime={
                                      field.field_label === "End Date & Time" &&
                                      dateValues["Start Date & Time"] &&
                                      dateValues["End Date & Time"] &&
                                      new Date(
                                        dateValues["Start Date & Time"],
                                      ).toDateString() ===
                                        new Date(
                                          dateValues["End Date & Time"],
                                        ).toDateString()
                                        ? new Date(
                                            dateValues["Start Date & Time"],
                                          )
                                        : setHours(setMinutes(new Date(), 0), 0)
                                    }
                                    maxTime={setHours(
                                      setMinutes(new Date(), 59),
                                      23,
                                    )}
                                    required={Number(field.is_required) === 1}
                                  />
                                </div>
                              )}
                            </>
                          )}

                          {errors[field.field_name] && (
                            <div className="error-message">
                              {errors[field.field_name]}
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              {permitCategory !== "isolation" && (
                <button
                  className="data-form-save-button"
                  type="button"
                  onClick={() => handleSaveClick("Draft")}
                  disabled={isLoading}
                >
                  {isLoading ? "Saving..." : "Save as Draft"}
                </button>
              )}
              <button
                className="request-button"
                type="button"
                onClick={() => handleSaveClick("Submitted")}
                disabled={isLoading}
              >
                {isLoading ? "Sending Request..." : "Send Request"}
              </button>
              <button
                className="data-form-cancel-button"
                type="button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default PermitRequestForm;
